import get from 'lodash/get';
import filter from 'lodash/filter';

import supportedLocales from './locales';
import allMessages from './translations/langs.json';
import store from '../../sdk/store';

const DEFAULT_LOCALE = 'en_us';

export const getLocale = () => {
  const forcedLang = store.get('lang');
  const lang = forcedLang || get(navigator, ['languages', 0], navigator.browserLanguage || DEFAULT_LOCALE);
  return lang;
};

export const getLocaleFormatted = () => {
  const locale = getLocale();

  return locale && locale.toLowerCase().replace('-', '_');
};

export const locale = getLocaleFormatted();
export const messages = allMessages[locale];

export const getAllowedLocales = () =>
  filter(supportedLocales, l => !l.hidden || process.env.NODE_ENV === 'development');
